import { render, staticRenderFns } from "./EventRegexEdit.vue?vue&type=template&id=59ff4419"
import script from "./EventRegexEdit.vue?vue&type=script&lang=js"
export * from "./EventRegexEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports